import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeHtml,
  SafeValue
} from '@angular/platform-browser';

@Pipe({ name: 'safeResourceUrl', standalone: true })
export class SafeResourceUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(
    value: string | SafeHtml | SafeResourceUrl | null | undefined
  ): SafeResourceUrl | null {
    if (value == null) return null;
    if (typeof value !== 'string') return value as SafeResourceUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}